module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAMAAABFjsb+AAAAQlBMVEVHcEzXKyfZLSbYLCbYKifXKyfZJyfXKyfXKyfXKyfXKyfYKyfYKyfXKyfXKibXKyfXKSbXKyfYKyfXKyjXKifXKyf4Ot4hAAAAFXRSTlMAhhgrJOQM9L7b7bJxekj5Qc+dX6rDTwYLAAAAlUlEQVQY01WQWRaFIAxDy1wGBdTuf6uPIvIgX3BPaEMAWPK+sOJ1S5hKnl75NIh96K/HdhZpVWR40K4DQIcVOEdB7zajLjbihkp7hdBi5DyQLo4DgWmrlF8QGfaFIj2j073B+zx3Sj9Rmyd6hFNPRAJUP7qU8hdRwWtcJLgC3BD2EuQKcVRoxffnIOwsVadYfY2H6rcf+e8TyCpQ4U0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/gou_yes.png
// module id = KtNK
// module chunks = 1